import { RateModelDto } from './ratemodeldto';
import { AdministrativeFeeCatalogDto } from './administrativefeecatalogdto';

export class OwnAdministrativeFeeDto {
    idOwnAdministrativeFee?: number;
    active?: string;
    rateModelDto?: RateModelDto;
    administrativeFeeCatalogDto?: AdministrativeFeeCatalogDto;

    constructor(init?: Partial<OwnAdministrativeFeeDto>) {
        Object.assign(this, init);
    }
}